export const theme = {
  color: {
    primary: {
      active: '#009A68',
      default: '#3DBA90',
      hover: '#79CEAF',
      disabled: '#9EDCC7',
      background: '#DEF3EC',
      lightBackground: '#d1f0e5',
    },
    secondary: {
      active: '#C40D5A',
      default: '#EB1362',
      hover: '#EE3C7A',
      disabled: '#F589B0',
      background: '#FCE4EC',
    },
    thirdary: {
      active: '#ED7B19',
      default: '#F8971D',
      hover: '#F9A433',
      disabled: '#FBCB8E',
      background: '#FEF2E1',
    },
    text: {
      white: '#FFF',
      B6: '#454545',
      B5: '#6B6B6B',
      B4: '#989898',
      B3: '#AAAAAA',
      B2: '#BDBDBD',
      B: '#D2D2D2',
      HB: '#EEEEEE',
      F: '#F6F6F6',
    },
    semantic: {
      success: '#A0D45E',
      info: '#4DBAE9',
      warning: '#FDB531',
      error: '#EE415D',
      /**
       * @description specific usage
       */
      enterprise: '#3E5871',
      team: '#FF6A6A',
      pro: '#36B6ED',
    },
  },
  typography: {
    fontSize: {
      h1: 36,
      h2: 32,
      h3: 28,
      h4: 24,
      h5: 20,
      h6: 16,
      p: 14,
      span: 14,
      div: 14,
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      bold: 700,
    },
  },
  zIndex: {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },
};
